import * as React from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'

import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

import { turnoverComingSoonImage } from 'modules/engagement_insights/assets/Images/index'

const TurnoverWidgetComingSoon = () => {
  const title = i18n.t('engagement_insights.coming_soon.title')
  const description = i18n.t('engagement_insights.coming_soon.description')
  const description_turnover = i18n.t('engagement_insights.coming_soon.description_turnover')
  const HELP_CENTER_URL = 'https://factorialhr.com/blog/causes-high-turnover-rate/'

  const goToHC = (event: React.MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault()
    track(trackingEvents.engagementInsights.goToTurnoverHC)
    window.open(HELP_CENTER_URL)
  }

  const orangeElipse = (
    <Box
      background="champagne800"
      style={{
        width: '70%',
        height: '70%',
        position: 'absolute',
        borderRadius: '50%',
        bottom: '30%',
        left: '50%',
        filter: 'blur(97px)',
        opacity: '0.2',
      }}
    />
  )

  const purpleElipse = (
    <Box
      background="radicalRed800"
      style={{
        width: '470px',
        height: '100%',
        position: 'absolute',
        borderRadius: '50%',
        bottom: '70%',
        left: '-45%',
        filter: 'blur(65px)',
        opacity: '0.2',
      }}
    />
  )

  return (
    <Box
      borderRadius={{
        all: 'abs008',
      }}
      style={{
        position: 'relative',
        overflow: 'hidden',
        flex: '1 0 0',
      }}
      background="grey100"
      alignItems="center"
    >
      {orangeElipse}
      {purpleElipse}
      <Box style={{ margin: '36px 32px 0' }}>
        <img src={turnoverComingSoonImage} alt="turnover coming soon" style={{ zIndex: 1 }} />
      </Box>
      <Box gap="s8" padding="s24">
        <Box>
          <Text weight="semibold" color="grey1000" size="400">
            {title}
          </Text>
        </Box>
        <Text weight="normal" color="grey800" size="300">
          {description}
          <a
            style={{ outline: 0 }}
            onClick={(event: React.MouseEvent<HTMLAnchorElement>) => goToHC(event)}
          >
            {description_turnover}
          </a>
        </Text>
      </Box>
    </Box>
  )
}

export default TurnoverWidgetComingSoon
